// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay__1uI0n","overlayOffset":"overlayOffset__tFI8G"};